import React from "react";
import "./DgoAdditionalCoverageInfoDialogStyles.scss";
import {Dialog} from "@material-ui/core";
import carAccidentImage from "../../../../../../images/car_accident.svg"
import {ReactSVG} from "react-svg";
import {Button} from "../../../../../../components/Button";
import {strings} from "../../../../../../strings/strings";
import useSwitchToNewContent from "../../../../../../utils/hooks/useSwitchToNewContent";

interface DgoAdditionalCoverageInfoDialog {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

export const DgoAdditionalCoverageInfoDialog = ({open, onConfirm, onClose}: DgoAdditionalCoverageInfoDialog) => {
    const showNewContent = useSwitchToNewContent();

    const handleConfirm = () => {
        onConfirm();
    };
    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog open={open} disableBackdropClick={true}>
            <div className={"dgo-info-dialog"}>
                <div className={"dgo-info-dialog__content fluid"}>
                    <ReactSVG src={carAccidentImage}/>

                    <span className={"dgo-info-dialog__content__title"}>{strings.important}</span>

                    <p className="dgo-info-dialog__content__text">
                        {showNewContent ? strings.dgoInfo1in2025 : strings.dgoInfo1}
                        <span className="dgo-info-dialog__content__text_accent">
                            {strings.dgoInfo2}
                        </span>
                        {strings.dgoInfo3}
                    </p>

                    <div className={"dgo-info-dialog__content__controls"}>
                        <Button label={strings.dgoChoose} onClickListener={handleConfirm}/>
                    </div>
                    <div className={"dgo-info-dialog__content__controls"}>
                        <Button label={strings.dgoDontChoose} onClickListener={handleClose} variant={'notSelected'}/>
                    </div>
                </div>
            </div>
        </Dialog>
    )
};